<template>
  <div class="scenario-error-footer-contents">
    <template v-for="(error, i) in errorList">
      <div v-if="errorItemNumber === i" class="error-contents" :key="i">
        <h3>ご確認ください {{i + 1}}/{{errorList.length}}</h3>
        <article>
          <p><i class="mdi mdi-alert-circle"></i> {{error.contents}}</p>
          <p>{{error.solution}}</p>
        </article>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    errorItemNumber: {
      require: false
    },
    errorList: {
      require: false
    },
  }
}
</script>

<style lang="scss" scoped>
.scenario-error-footer-contents {
  width: 100%;
  .error-contents {
    margin-top: 8px;
    padding: 0 16px;
    width: 100%;
    font-size: 14px;
  }
  h3 {
    font-weight: bold;
    color: red;
  }
  article {
    margin-top: 8px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/molecules/chatbot/footers/ScenarioErrorFooterContents.vue